/* eslint-disable @typescript-eslint/no-unused-vars */
import { type DossierJsonldRead, type Status } from '@europrocurement/l2d-domain';
import { createContext, useContext } from 'react';
import { type DisplayedDocument } from './types';
import { type DossierDocument, type DossierFichier } from '../hooks/useDossierDocuments';

const statuses: Array<Status> = [];
const setStatuses: React.Dispatch<React.SetStateAction<Status[]>> = () => {};
const getStatusLabel = (statusId: number): string | undefined | null => (statusId ? null : null);

const documents: Array<DossierDocument> = [];
const addDocument = (document: DossierDocument) => {};
const removeDocument = (documentId: number) => {};
const fichiers: Array<DossierFichier> = [];
const getFichiers = (): DossierFichier[] => [];
const addFichier = (fichier: DossierFichier) => {};
const addMultipleFichiers = (newFichiers: DossierFichier[]) => {};
const removeFichier = (fichier: DossierFichier) => {};
const replaceFichier = (oldFichier: DossierFichier, newFichier: DossierFichier) => {};
const replaceFichierById = (oldFichierId: number, newFichier: DossierFichier) => {};
const getDownloadableDocumentsCount = (checkDocumentReady?: boolean): number => 0;

const getRequiredMissingDocumentsCount = (): number => 0;
const setDocuments: React.Dispatch<React.SetStateAction<DossierDocument[]>> = () => {};
const setFichiers: React.Dispatch<React.SetStateAction<DossierFichier[]>> = () => {};
const setDossierFromParcours: React.Dispatch<React.SetStateAction<DossierJsonldRead>> = () => {};
const getAllDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];
const getPrescriberDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const getPrescriberAdditionalDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const getFormalisteDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const getFormalisteAdditionalDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const getInternalDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const getInternalAdditionalDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const getRequiredMissingDocuments = (
    defaults: Record<string, unknown> | undefined = {},
): DisplayedDocument[] => [];

const documentDataLoaded = () => false;
const refreshDocumentContext = (): void => {};

export type DocumentContextType = {
    statuses: Array<Status>;
    setStatuses: React.Dispatch<React.SetStateAction<Status[]>>;
    getStatusLabel: (statusId: number) => string | undefined | null;
    documents: Array<DossierDocument>;
    removeDocument: (documentId: number) => void;
    addDocument: (document: DossierDocument) => void;
    fichiers: Array<DossierFichier>;
    getFichiers: () => DossierFichier[];
    addFichier: (fichier: DossierFichier) => void;
    addMultipleFichiers: (newFichiers: DossierFichier[]) => void;
    removeFichier: (fichier: DossierFichier) => void;
    replaceFichier: (oldFichier: DossierFichier, newFichier: DossierFichier) => void;
    replaceFichierById: (oldFichierId: number, newFichier: DossierFichier) => void;
    getDownloadableDocumentsCount: (checkDocumentReady?: boolean) => number;
    getRequiredMissingDocumentsCount: () => number;
    setDocuments: React.Dispatch<React.SetStateAction<DossierDocument[]>>;
    setFichiers: React.Dispatch<React.SetStateAction<DossierFichier[]>>;
    setDossierFromParcours: React.Dispatch<React.SetStateAction<DossierJsonldRead>>;
    getAllDocuments: (defaults: Record<string, unknown> | undefined) => DisplayedDocument[];
    getPrescriberDocuments: (defaults: Record<string, unknown> | undefined) => DisplayedDocument[];
    getPrescriberAdditionalDocuments: (
        defaults: Record<string, unknown> | undefined,
    ) => DisplayedDocument[];
    getFormalisteDocuments: (defaults: Record<string, unknown> | undefined) => DisplayedDocument[];
    getFormalisteAdditionalDocuments: (
        defaults: Record<string, unknown> | undefined,
    ) => DisplayedDocument[];
    getInternalDocuments: (defaults: Record<string, unknown> | undefined) => DisplayedDocument[];
    getInternalAdditionalDocuments: (
        defaults: Record<string, unknown> | undefined,
    ) => DisplayedDocument[];
    getRequiredMissingDocuments: (
        defaults: Record<string, unknown> | undefined,
    ) => DisplayedDocument[];
    documentDataLoaded: () => boolean;
    refreshDocumentContext: () => void;
};

const DocumentContext = createContext({
    statuses,
    setStatuses,
    getStatusLabel,
    documents,
    fichiers,
    setDocuments,
    addDocument,
    removeDocument,
    getFichiers,
    setFichiers,
    addFichier,
    addMultipleFichiers,
    removeFichier,
    replaceFichier,
    replaceFichierById,
    getRequiredMissingDocuments,
    getRequiredMissingDocumentsCount,
    getDownloadableDocumentsCount,
    getAllDocuments,
    getPrescriberDocuments,
    getPrescriberAdditionalDocuments,
    getFormalisteDocuments,
    getFormalisteAdditionalDocuments,
    getInternalDocuments,
    getInternalAdditionalDocuments,
    documentDataLoaded,
    refreshDocumentContext,
    setDossierFromParcours,
});

export const useDocumentContext = () => useContext(DocumentContext);

export default DocumentContext;
